
















import Vue from 'vue';

export default Vue.extend({
  name: 'wizard-component',
  props: {
    steps: Number,
    activeStep: Number
  }
});
